import { ReactNode } from 'react';

import { ChakraProvider, SystemContext } from '@chakra-ui/react';

// Direct module import: the theme barrel would also build the unused esi/wc/app-preview systems on the client
import raspberrySsrTheme from '@nocowanie/common-ui/theme/raspberry-theme/ssr.theme';

export const ThemeProvider = ({
    theme,
    children,
}: {
    theme?: SystemContext;
    children: ReactNode;
}): ReactNode => {
    return <ChakraProvider value={theme ?? raspberrySsrTheme}>{children}</ChakraProvider>;
};
